import React, {Fragment} from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { compose, lifecycle, branch, renderComponent, withState, withHandlers } from 'recompose';
import { withRouter } from 'react-router-dom';
import { withStyles } from '@material-ui/core/styles';
import * as moment from 'moment';

import { selectUserModule, resetelectedContent, resetUserPrograms } from '../redux/reducers/userProgramsFull';
import { toggleUserDashboard } from '../redux/reducers/view';
import { getUserModules, selectedProgram, getModulesForProgram, getUserPrograms } from '../redux/selectors';
import { CookiesProvider, Cookies } from 'react-cookie';
import Spinner from './Spinner';
import ModulesCard from './ModulesCard';

import { COLORS, commonStyles } from '../styles/styles';
import { convertTime } from '../utils';
import { changeRedirectFlag } from '../redux/reducers/userOverallReport';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';
import ScaleLoader from 'react-spinners/ScaleLoader';


import { MDBCard, 
  MDBCardBody, 
  MDBCardTitle, 
  MDBCardText, 
  MDBCardHeader, 
  MDBBtn, 
  MDBContainer, 
  MDBTabPane, 
  MDBTabContent, 
  MDBNav, 
  MDBNavItem, 
  MDBNavLink, 
  MDBDropdown,
  MDBDropdownItem,
  MDBDropdownToggle,
  MDBDropdownMenu,
  MDBRow,
 
  MDBCol,
  MDBIcon} from "mdbreact";
import { contentListRequest } from '../redux/reducers/contentList';
const cookies = new Cookies();
const LearnerModulesList = ({ classes, modules,modulesListReducer, onLearnerModuleClick, handleBack, ...props }) => {
  const renderModules = () => (
    modules && modules.map(item => (
        <div className="col-lg-3 col-md-6 col-sm-6" style={{paddingLeft:5, paddingRight:5}}  key={item.programId} onClick={() => onLearnerModuleClick(item)} >
       
        <div
        
          key={item.moduleId}
          style={{width:'100%'}}
         
        >
           
          <ModulesCard
            type="moduleCard"
            name={item.name}
            description={item.description}
            startDate={
              item.startDate && item.startDate !== null ? convertTime(item.startDate.date) : ''
            }
            moduleItem={item}
            dueDate={item.dueDate && item.dueDate !== null ? convertTime(item.dueDate.date) : ''}
            isSelected={false}
            percentageComplete={item.percentageComplete}
            status={item.status}
            isActive={true}
            background={item.thumbLoc}
          />
        </div>
        </div>
      )
    )
  )

  return <MDBCard  className="z-depth-2 rounded-0 yellow-card">
     <MDBBtn
        floating
        left
        tag='a'
        size='sm'
        className='ml-auto ml-4  d-md-none navBack'
        action
        onClick={()=>handleBack()}
      >
      <MDBIcon icon='angle-left' className="secondary-color" size="sm"/>
    </MDBBtn>
  <div className='text-dark gothamBlack text-left pt-3 pl-3 mobile-padding'>
        MODULES
        </div>
        
    <div style={{height:1, backgroundColor:'#CCCCCC', marginTop:15}}></div>
      <div className="contentScrollMod">
      
        <MDBRow style={{width:'100%', margin: '0 auto'}}>{renderModules()}</MDBRow>
      </div>
      <ReactCSSTransitionGroup
          transitionName="fade"
          transitionEnterTimeout={500}
          transitionLeaveTimeout={500}>{((modulesListReducer.fetching==true)) && <div onClick={(e)=>e.stopPropagation() } style={{pointerEvents:'all',backgroundColor:'#FFFFFF', position:'absolute', top:0, left:0, height:'100%', width:'100%', zIndex:12000, textAlign:'center'}}>
          <div style={{position:'absolute', top:"40%", width:'100%'}}>
        <ScaleLoader
         
         height={35}
         width={4}
         radius={2}
         margin='2px'
         color={COLORS.cornerstoneRed}
         loading={true}
       />
       </div>
        </div>}</ReactCSSTransitionGroup>
</MDBCard>;
};

const styles = () => ({
  ...commonStyles,
});

const mapStateToProps = state => ({
  view: state.viewReducer,
  loginReducer: state.loginReducer,
  programs: getUserPrograms(state),
  userModules: getModulesForProgram(state),
  getProgram: selectedProgram(state),
  modules: state.modulesListReducer.modules,
  modulesListReducer: state.modulesListReducer
});

const mapDispatchToProps = dispatch => ({
  selectUserModule: moduleId => dispatch(selectUserModule(moduleId)),
  toggleUserDashboard: value => dispatch(toggleUserDashboard(value)),
  resetelectedContent: () => dispatch(resetelectedContent()),
  changeRedirectFlag: value => dispatch(changeRedirectFlag(value)),
  resetUserPrograms: () => dispatch(resetUserPrograms()),
  getContentList: () => dispatch(contentListRequest())
});

export default compose(
  withRouter,
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
  withState('initialSelectionModule', 'handleInitialSelectionModule', false),
  withHandlers({
    handleBack: props => () => {
      if(props.match.path=='/modules/:programId'){
        props.resetUserPrograms();
        props.history.push('/programs'+ props.history.location.search)
       }
       if(props.match.path=='/assessments/:programId'){
        props.resetUserPrograms();
        props.history.push('/chooseassessment'+ props.history.location.search)
       }
       if(props.match.path=='/tools/:programId'){
        props.resetUserPrograms();
        props.history.push('/choosetool'+ props.history.location.search)
       }
    },
    onLearnerModuleClick: props => (item) => {
      const { selectUserModule, resetelectedContent, toggleUserDashboard, view } = props;
      //props.changeRedirectFlag(false);
      
      if(item.components!=0){
        selectUserModule(item.moduleId);
        resetelectedContent();
        props.history.push('/content/'+props.getProgram.programId+'/'+item.moduleId+ props.history.location.search);
        if (view.isUserDashboardOpened) {
          toggleUserDashboard(false);
        }
        console.log('pepe5a')
        props.getContentList()
      }
      
      
    
    },
  }),
  lifecycle({
    componentWillReceiveProps(nextProps) {

    },
  }),
  withStyles(styles),
)(LearnerModulesList);

LearnerModulesList.propTypes = {
  classes: PropTypes.instanceOf(Object),
  userModules: PropTypes.instanceOf(Array),
  onLearnerModuleClick: PropTypes.func,
};
